import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {BBResponseContainer} from '../common-services/response-container';
import {map, tap, timeout} from 'rxjs/operators';
import {PreparePlatesRequest} from '../ngs-work-list/model/prepare-plates-request';
import {NextStepProcessRequest} from '../ngs-work-list/model/next-step-process-request';
import {SampleUpdateList} from '../ngs-work-list/model/sample-update';
import {RunQualityAndConcentration} from '../ngs-work-list/model/run-quality-and-concentration';
import {DirectPrintRequest} from '../print-plate-labels/ngs-print-request';
import {TagTypeSwitchUpdateRequest} from '../ngs-work-list/model/tag-type-swith-update-request';
import {TagUpdateRequest} from "../ngs-work-list/model/tag-update-request";

@Injectable({
  providedIn: 'root'
})
export class BatchProcessService {

  readonly CARRIER_STATE_MDM_SERVICE = 'mdm/carrier/state/rnaLib';
  readonly QC_EVAL_SERVICE='qcAnalysis'
  constructor(private http: HttpClient) {
  }


  getPlateAndPlateFirstEmptyColumn(workListId: string, labId: string): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/plates';
    const requestParam = new HttpParams().set('workListId', workListId).set('labId', labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  getLibraryTypeData(labId: string): Observable<any> {
    let url = environment.BB_MDMSERVICE_URL + "/mdm/generic/"+labId+"/libTypes/list";
    let requestParam = new HttpParams().set("activeIndicator", "true");
    const options = url ? { params: requestParam } : {};
    return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout),tap(error => {
        error.url = url;
    }));
  }

  getRunId(labID_Barcodes:any): Observable<BBResponseContainer> {
    let url = environment.BB_LAB_MEASUREMENT_URL + this.QC_EVAL_SERVICE+"/runAndHandler";
    return this.http.put<BBResponseContainer>(url, labID_Barcodes).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
   }

   getRunIdDetails(labid_runids_batcid:any): Observable<BBResponseContainer> {
   let url = environment.BB_LAB_MEASUREMENT_URL + this.QC_EVAL_SERVICE+"/getRunConcAndQuality";
   return this.http.put<BBResponseContainer>(url, labid_runids_batcid).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
     error.url = url;
   }));
 }

  getImportImages(requestObject: any): Observable<BBResponseContainer> {
    let url = environment.BB_LAB_MEASUREMENT_URL + 'lab/measurement/importimages';
    return this.http.put<BBResponseContainer>(url, requestObject).pipe(timeout(60000));
 }

 getPlateViewDetails(plateBarcode: string,ispartialCopy:any, labId: string): Observable<BBResponseContainer> {
  let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/plate';
  const requestParam = new HttpParams().set('plateBarcode', plateBarcode).set('ispartialCopy' ,ispartialCopy).set('labId', labId);
  const options = url ? { params: requestParam } : {};
  return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
    error.url = url;
  }));
}

getStoragePlateViewDetails(plateBarcode: string, labId : string): Observable<BBResponseContainer> {
  let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/storagePlateView';
  let requestParam = new HttpParams().set('plateBarcode', plateBarcode).set("labId",labId);
  const options = url ? { params: requestParam } : {};
  return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
    error.url = url;
  }));
}

updatePlateSavedValue(worklistId: string, plateBarcode: any, labId: string): Observable<BBResponseContainer>  {
  const url = environment.BB_NGS_LIB_PREP_URL + `worklist/worklistplatesaved/${worklistId}/${labId}`;
  return this.http.put<BBResponseContainer>(url, plateBarcode).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
    error.url = url;
  }));
}

  //Prepare plates for Samples
  preparePlatesForSamples(preparePlatesRequest: PreparePlatesRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/plates';
    return this.http.put<BBResponseContainer>(url, preparePlatesRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  savePlate(nextStepProcessRequest: NextStepProcessRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/saveplate';
    return this.http.put<BBResponseContainer>(url, nextStepProcessRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  updateSampleNextPlateWithCurrentPlate(workListId: string, sampleBarcodeList: string[], labId: string): Observable<BBResponseContainer>  {
    const url = environment.BB_NGS_LIB_PREP_URL + `worklist/samples/nextplate/${workListId}/${labId}`;
    return this.http.put<BBResponseContainer>(url, sampleBarcodeList).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  getWorkFileNameFromMDM(labId:string,processStep: string, process: string, workfileDef : string[]): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + 'mdm/workfile'+"/getworkFileName";
    let requestParam = new HttpParams().set('labId', labId).set('processStep', processStep).set('processName', process).set('workfileDef', workfileDef.join(','));
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
      }));
    }

    //generate Hamilton Workfiles
    generateWorkFiles(nextStepProcessRequest: NextStepProcessRequest): Observable<BBResponseContainer> {
      let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/generateworkfiles';
      return this.http.put<BBResponseContainer>(url, nextStepProcessRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
      }));
    }

    getSampleMeasurementIdmap(barcodes: string[], lab: string) :  Observable<BBResponseContainer> {
      let request = {
        'barcodes' :  barcodes,
       'lab' : lab
      };
      const url = environment.BB_LAB_MEASUREMENT_URL + 'ngs/sample/measurementid';
     return this.http.put<BBResponseContainer>(url, request).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
       error.url = url;
      }))
   }

    //Move Samples to next Step
    moveSamplesToNextStep(nextStepProcessRequest: NextStepProcessRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/nextstep';
    return this.http.put<BBResponseContainer>(url, nextStepProcessRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  updateCommentOnSample(sampleUpdate: SampleUpdateList): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/samples/comment';
    return this.http.put<BBResponseContainer>(url, sampleUpdate).pipe(timeout(environment.defaultTimeout));
 }

 setQCResultsInMeasurements(requestObj: any) {
  let url = environment.BB_LAB_MEASUREMENT_URL + this.QC_EVAL_SERVICE + "/updateMetricsAndStatus";
  return this.http.patch<BBResponseContainer>(url, requestObj).pipe(timeout(environment.defaultTimeout));
}

updateQualityAndConcentrationPerMeasurement(requestObj: {}) {
  let url = environment.BB_LAB_MEASUREMENT_URL + this.QC_EVAL_SERVICE+"/updateQCPreference";
  return this.http.patch<BBResponseContainer>(url, requestObj).pipe(timeout(environment.defaultTimeout));
}

saveAndSend(requestObj: any) {
  let url = environment.BB_NGS_LIB_PREP_URL + "/worklist/qcEvaluation/saveAndSend";
  return this.http.put<BBResponseContainer>(url, requestObj).pipe(timeout(environment.defaultTimeout));
}

updateQualityAndConcentrationPerRun(runQualityConc:RunQualityAndConcentration)
{

  let url = environment.BB_LAB_MEASUREMENT_URL + this.QC_EVAL_SERVICE+"/samples/measurement";
  return this.http.post<BBResponseContainer>(url,runQualityConc).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
    error.url = url;
  }));
}

   //Update samples data with updated worklist
   updateSamplewithUsedAmount(updateRequestObject: any): Observable<BBResponseContainer> {
     let url = environment.BB_NGS_LIB_PREP_URL + 'processstep/samples/updateUsedAmount';
    return this.http.put<BBResponseContainer>(url, updateRequestObject).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  getLibtypesMap(labId: string) {
    let url = environment.BB_MDMSERVICE_URL + "mdm/libtypes/map";
    let requestParam = new HttpParams().set('labId', labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  updateWorkListwithWorkListSaved(batchId: string,isPartialCopy:boolean, labId: string) {
    const url = environment.BB_NGS_LIB_PREP_URL + `worklist/update/workfilesaved/${batchId}/${isPartialCopy}/${labId}`;
    const options = {};
    return this.http.put<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  getTagMaps(tagSystemName: string, labId: string, flag: boolean): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + 'mdm/tagmaps/' + labId + '/' +tagSystemName + '/' + flag.toString();
    const options = {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  performTagAssignment(request: any) {
    let url = environment.BB_NGS_LIB_PREP_URL + "/tags/asssignment";
    return this.http.put<BBResponseContainer>(url, request).pipe(timeout(environment.defaultTimeout));
  }

  tagSeqExistanceCheck(request: any) {
    let url = environment.BB_NGS_LIB_PREP_URL + "/tags/tagSeqExistanceCheck";
    return this.http.patch<BBResponseContainer>(url, request).pipe(timeout(environment.defaultTimeout));
  }

  generatePreseqPoolId(labId:string) {
    let url =environment.BB_NGS_LIB_PREP_URL + "/preSeq/sequence/genrate";
    return this.http.patch<BBResponseContainer>(url, labId).pipe(timeout(environment.defaultTimeout));
  }
  saveAndUpdatePreseqPool(request:any){
    let url = environment.BB_NGS_LIB_PREP_URL + "/preSeq/savePooledLib";
    return this.http.post<BBResponseContainer>(url, request).pipe(timeout(120000));
  }

  createEntryQcWorkfile(request:any , preseqFlag:boolean){
    let urlPart = preseqFlag ? "/preSeqPooling":"/preHybPooling"
    let url = environment.BB_NGS_LIB_PREP_URL + urlPart+"/workfile";
    return this.http.post<any>(url, request).pipe(timeout(environment.defaultTimeout));
  }

  printSampleLabels(printRequest: DirectPrintRequest): Observable<BBResponseContainer> {
    let url = environment.BB_PRINT_SERVICE_URL + 'printLabel'
    return this.http.post<BBResponseContainer>(url, printRequest);
  }

  removeTagInfoFromLibraries(tagTypeSwitchUpdateRequest: TagTypeSwitchUpdateRequest) {
    let url = environment.BB_NGS_LIB_PREP_URL + 'worklist/remove/taginfo';
    return this.http.patch<BBResponseContainer>(url, tagTypeSwitchUpdateRequest).pipe(timeout(environment.defaultTimeout));
  }

  genericFileUpload(formData: FormData) {
    let url = environment.BB_NGS_LIB_PREP_URL + 'api/file/upload';
    return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout));
  }

  genericFileDownload(downloadType: string, jsonString: string) {
    let url = environment.BB_NGS_LIB_PREP_URL + '/api/file/download';
    let jsonRequest = {'downloadType': downloadType, 'requestParam': jsonString}
    return this.http.put(url, jsonRequest, { observe: 'response', responseType: 'blob' }).pipe(
      map((res) => {
        return {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
      })
    );
  }

  getTagsDataForEditingTags(labId: string, tagPlateId: string, tagSystem: string) {
    const url = environment.BB_NGS_LIB_PREP_URL + "tags/map";
    const requestParam = new HttpParams().set('labId', labId).set("tagPlateId", tagPlateId).set("tagSystem", tagSystem);
    const options = { params: requestParam }
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  saveEditedTags(tagUpdateRequest: TagUpdateRequest) {
    const url = environment.BB_NGS_LIB_PREP_URL + 'tags/manual/save';
    return this.http.patch<BBResponseContainer>(url, tagUpdateRequest).pipe(timeout(environment.defaultTimeout));
  }
}
